import { TypedTypePolicies } from 'owa-graph-schema-type-policies';
import { EntityCommand } from 'owa-graph-schema';
import { getSelectedApp } from 'owa-appbar-state';

export const M365ApplicationTypePolicies: TypedTypePolicies = {
    M365Application: {
        fields: {
            isInUse: {
                read(_existing, { readField }) {
                    const commandField: EntityCommand | undefined = readField('command');
                    return getSelectedApp() === commandField?.entity.entityId;
                },
            },
        },
    },
};
